import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_PRODUCT_BASIC_INCO: string = typeCreatorV2(
  'ProductReducer',
  'SetProductBasicInfo'
);
export const SET_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SetSharingProduct'
);

export const SET_PRODUCT_LOCATION: string = typeCreatorV2(
  'ProductReducer',
  'SetLocationProduct'
);

export const SEND_EMAIL_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SendEmailEditProductPage'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'ProductReducer',
  'SetCustomerEditProductPage'
);

export const SET_CLIENT_COLLECTION_PERSONAL: string = typeCreatorV2(
  'ProductReducer',
  'SetClientCollectionPersionalEditProductPage'
);

export const SET_ADD_ASSIGN_CLIENTS: string = typeCreatorV2(
  'ProductReducer',
  'SetAddAssignClientEditProductPage'
);

export const SET_ADD_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SetAddSharingProductEditProductPage'
);

export const SET_ADD_COLLECTIONS: string = typeCreatorV2(
  'ProductReducer',
  'SetAddCollectionEditProductPage'
);

export const DELETE_COLLECTION: string = typeCreatorV2(
  'ProductReducer',
  'DeleteCollectionEditProductPage'
);

export const SET_ASSIGNESS: string = typeCreatorV2(
  'ProductReducer',
  'SetAssigness'
);

export const SET_CUSTOMER_NAME: string = typeCreatorV2(
  'ProductReducer',
  'SetCustomerName'
);

export const SET_PROPERTY_NAME: string = typeCreatorV2(
  'ProductReducer',
  'SetPropertyName'
);

export const SET_STATUS_LANE: string = typeCreatorV2(
  'ProductReducer',
  'SetStatusLane'
);

export const ADD_NEW_TASK: string = typeCreatorV2(
  'ProductReducer',
  'AddNewTask'
);

export const UPLOAD_FILE_TASK: string = typeCreatorV2(
  'ProductReducer',
  'UploadFileTask'
);

export const SET_PRODUCT_DOCUMENT: string = typeCreatorV2(
  'ProductReducer',
  'SetProductDocument'
);

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'ProductReducer',
  'SetClientMiniProfile'
);

export const SEND_EMAIL_ADVANCE_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SendEmailAdvance'
);

export const RESET_DOCUMENT: string = typeCreatorV2(
  'ProductReducer',
  'ResetDocument'
);
